/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import styled from 'styled-components';
import Row from 'react-bootstrap/Row';

export const Heading = styled.h6`
  margin-top: 15px;
`;

export const HeaderRow = styled(Row)`
  align-items: center;
  margin: 0 5%;
  @media (max-width: 360px) {
    margin: 0 2%;
  }
`;

export const Container = styled.div`
  width: 100%;
`;

export const Previous = styled.a`
  font-size: 30px;
  color: black;
  opacity: ${(props) => (props?.disabled ? 0.2 : 1)};
  padding: 5%;
`;
export const Cancel = styled.a`
  font-size: 30px;
  color: black;
  opacity: ${(props) => (props?.disabled ? 0.2 : 1)};
  float: right;
  padding: 5%;
`;
export const Step = styled.h6`
  font-size: 12px;
  float: right;
  margin-top: 15px;
`;
export const Containers = styled.div`
  max-width: 100%;
  height: 15px;
  margin-top: 10px;
  background-color: #e0e0de;
  border-radius: 50;
`;
export const FillerStyle = styled.div`
  height: 100%;
  width: ${(props) => props?.fillWidth}%;
  background-color: ${(props) => props?.color ?? '#5c5c5c'};
  border-radius: inherit;
`;
